var Vue = require('vue');
var ResourceList = require('../../lib/components/ResourceList.vue').default;
var Marker = require('../../lib/markers/marker.js');
var Deletism = require('../../lib/markers/deletism.js');
var Undeletism = require('../../lib/markers/undeletism.js');
var Copier = require('../../lib/markers/copier.js');
var IndexView = require('../../lib/index-view.js');
var Columnator = require('../../lib/columnator.js');

module.exports = function () {
  new Vue({
    el: '#panels',
    components: {
      ResourceList
    }
  });

  $('.filtertron').filtertron('panels', {
    expander: '#filtertronExpander'
  });

  new IndexView;

  var marker = new Marker('panel');

  new Deletism(marker);
  new Undeletism(marker);
  new Copier(marker);

  new Columnator;
};
